/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {
    Modal,
    Button,
    Input,
    Popover,
    OverlayTrigger,
    Row,
    Col,
    Collapse
} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import {connect} from 'react-redux';



var LinkEditDialog = React.createClass({
    getInitialState() {
        return {
            weight: "", capacity: "", srcPort: "", trgPort: "",
            portOpen: false,
            wtError: null,
            capError: null,
            srcPortError: null,
            trgPortError: null,
            link: {}
        };
    },

    componentWillReceiveProps(nextProps) {
        let linkInfo = nextProps.netVisInteract.linkInfo;
        if (!linkInfo) {
            linkInfo = {};
        }

        this.setState(Object.assign({}, this.state, {
            weight: linkInfo.weight ? linkInfo.weight.toPrecision(4) : "",
            capacity: linkInfo.capacity ? linkInfo.capacity.toPrecision(4) : "",
            srcPort: linkInfo.ports ? linkInfo.ports[linkInfo.source] : "",
            trgPort: linkInfo.ports ? linkInfo.ports[linkInfo.target] : "",
            srcPortError: null,
            trgPortError: null,
            link: linkInfo
        }));
    },

    wtChange(e) {
        let newWt = e.target.value;
        this.setState(Object.assign({}, this.state, {
            weight: newWt,
            wtError: numValidator(newWt, "Weight")
        }));
    },
    wtStatus() {
        if (this.state.wtError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    capChange(e) {
        let newCap = e.target.value;
        this.setState(Object.assign({}, this.state, {
            capacity: newCap,
            capError: numValidator(newCap, "Capacity")
        }));
    },
    capStatus() {
        if (this.state.capError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    srcPortChange(e) {
        let newSrcPort = e.target.value;
        // They can set the source port to nothing if the target port is also nothing
        if (newSrcPort === '' && this.state.trgPort === '') {
            this.setState(Object.assign({}, this.state, {
                srcPort: newSrcPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        let link = this.props.netVisInteract.linkInfo;
        this.setState(Object.assign({}, this.state, {
            srcPort: newSrcPort,
            srcPortError: portValidator(newSrcPort, link.source,
                this.props.net, link),
            trgPortError: portValidator(this.state.trgPort, link.target,
                this.props.net, link)
        }));
    },
    srcPortStatus() {
        if (this.state.srcPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    trgPortChange(e) {
        let newTrgPort = e.target.value;
        if (newTrgPort === '' && this.state.srcPort === '') {
            this.setState(Object.assign({}, this.state, {
                trgPort: newTrgPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        let link = this.props.netVisInteract.linkInfo;
        this.setState(Object.assign({}, this.state, {
            trgPort: newTrgPort,
            trgPortError: portValidator(newTrgPort, link.target,
                this.props.net, link),
            srcPortError: portValidator(this.state.srcPort, link.source,
                this.props.net, link)
        }));
    },
    trgPortStatus() {
        if (this.state.trgPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    linkError() {
        return Boolean(this.state.wtError || this.state.capError ||
            this.state.srcPortError || this.state.trgPortError);
    },

    editHandler() {
        // console.log("Entering link edit handler ");
        if (this.linkError()) {
            return;
        }
        let link = {
            source: this.state.link.source,
            target: this.state.link.target,
            weight: parseFloat(this.state.weight),
            capacity: parseFloat(this.state.capacity)
        };
        if (this.state.srcPort !== "" && this.state.srcPort ) {
            link.ports = {};
            link.ports[link.source] = parseInt(this.state.srcPort);
            link.ports[link.target] = parseInt(this.state.trgPort);
        }
        let newLinks = this.props.net.links.filter(l => l !== this.state.link);
        newLinks = newLinks.concat(link);
        this.props.editLink(Object.assign({}, this.props.net, {links: newLinks}));
    },

    togglePort() {
        this.setState(Object.assign({}, this.state, {portOpen: !this.state.portOpen}));
    },

    helpState() {
        if (this.linkError()) {
            return 'danger';
        } else {
            return 'info';
        }
    },

    helpPopover(){
        let errorHeader = null;
        let wtErrorP = null;
        let capErrorP = null;
        let srcPErrorP = null;
        let trgPErrorP = null;
        if (this.linkError()) {
            errorHeader = <h5>Errors:</h5>;
        }
        if (this.state.wtError) {
            wtErrorP = <p>{this.state.wtError}</p>;
        }
        if (this.state.capError) {
            capErrorP = <p>{this.state.capError}</p>;
        }
        if (this.state.srcPortError) {
            srcPErrorP = <p>{this.state.srcPortError}</p>;
        }
        if (this.state.trgPortError) {
            trgPErrorP = <p>{this.state.trgPortError}</p>;
        }
        return (<Popover id="addNodeHelpPopover" title="Edit Link Help">
            <p>Links must be assigned non-negative weights and capacities.</p>
            <p>If port numbers are given for a link end they must not be alread used by another link.</p>
            {errorHeader}
            {wtErrorP}
            {capErrorP}
            {srcPErrorP}
            {trgPErrorP}
        </Popover>);
    },



    render(){

        let source = this.props.netVisInteract.linkInfo.source;
        let target = this.props.netVisInteract.linkInfo.target;
        let layerInfo = null;
        let layer = this.props.netVisInteract.linkInfo.layer;
        if (layer) {
            layerInfo = <span> <em>Layer: {layer}</em></span>;
        }
        return (
            <Modal dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} show={this.props.open} onHide={this.props.close}
                   dialogClassName="add-node-net-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Network Link: {source}-{target} {layerInfo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal">
                            <Row><Col xs={10} xsOffset={2}><em>Required Link Attributes</em></Col></Row>
                            <Row>
                                <div className={this.wtStatus()}> {/* This enables status feedback on input and label  */}
                                    <Col xs={3}>
                                        <label className="control-label">Weight</label>
                                    </Col>
                                    <Col xs={3}>
                                        <input type="text" value={this.state.weight}
                                               onChange={this.wtChange}
                                               className="form-control"/>
                                    </Col>
                                </div>
                                <Col xs={3}>
                                    <label
                                        className="control-label">Capacity</label>
                                </Col>
                                <div className={this.capStatus()}>
                                <Col xs={3}>
                                         <input type="text" value={this.state.capacity}
                                               onChange={this.capChange}
                                               className="form-control"/>
                                </Col>
                                </div>
                            </Row>

                            <Row>
                                <Col xs={10} xsOffset={2}><a
                                    onClick={this.togglePort}><em>Optional Link
                                    Ports</em></a></Col>
                            </Row>
                            <Collapse in={this.state.portOpen}>
                                <div>
                                    <Row>
                                        <div className={this.srcPortStatus()}>
                                        <Col xs={3}>
                                            <label className="control-label">{source} Port</label>
                                        </Col>
                                        <Col xs={3}>
                                            <input type="text"
                                                   value={this.state.srcPort}
                                                   className="form-control" onChange={this.srcPortChange}/>
                                        </Col></div>
                                        <div className={this.trgPortStatus()}>
                                        <Col xs={3}> <label
                                            className="control-label">{target} Port</label></Col>
                                        <Col xs={3}>
                                            <input type="text" onChange={this.trgPortChange}
                                                   value={this.state.trgPort}
                                                   className="form-control"/>
                                        </Col>
                                            </div>
                                    </Row></div>
                            </Collapse>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary"
                            onClick={this.editHandler} disabled={this.linkError()}>Apply </Button>
                    <Button onClick={this.props.close}>Cancel</Button>
                    <OverlayTrigger trigger="click" placement="top"
                                    overlay={this.helpPopover()}>
                        <Button bsStyle={this.helpState()}>Help</Button>
                    </OverlayTrigger>
                </Modal.Footer>
            </Modal>
        )
    }
});

function numValidator(numString, name) {
    let value = parseFloat(numString);
    if (isNaN(value)) {
        return name + ": must be a valid number."
    }
    if (value < 0.0) {
        return name + ": must be non-negative."
    }
    return null;
}

function portValidator(portNumString, nodeID, net, link) {
    let portNum = parseInt(portNumString);
    if (isNaN(portNum)) {
        return nodeID + " port number is not a valid number";
    }
    let valid = true;
    let links = net.links.filter(l => l !== link); // Don't include this link
    let usedPorts = new Set();
    for (let link of links) {
        if (link.ports) {
            if (link.source === nodeID) {
                usedPorts.add(link.ports[link.source]);
                if (link.ports[link.source] === portNum) {
                    valid = false;
                }
            }
            if (link.target === nodeID) {
                usedPorts.add(link.ports[link.target]);
                if (link.ports[link.target] === portNum) {
                    valid = false;
                }
            }
        }
    }
    if (valid) {
        return null;
    }
    return nodeID + " port number " + portNum + " is already used, (used ports: " + Array.from(usedPorts).toString()+ ")";
}


const mapStateToProps = (state) => {
    return {
        open: state.uiState.showLinkEditModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_LINK_EDIT_DIALOG'});
        },
        editLink: (net) => {
            dispatch({type: 'NET_LINK_EDIT', net: net});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkEditDialog)




// WEBPACK FOOTER //
// ./src/netDraw/LinkEditDialog.js